<template>
  <v-form :submit="submitUpdate">
    <v-row>
      <v-col cols="12" md="3" sm="4">
        <v-text-field
                      label="Sigla"
                      :disabled="editGroup.id ? true : false"
                      v-model="editGroup.acronym"
                      :rules="rules.required"
                      density="compact"></v-text-field>
      </v-col>
      <v-col cols="12" md="5" sm="6">
        <v-text-field
                      label="Nome do grupo"
                      v-model="editGroup.name"
                      :rules="rules.required"
                      density="compact"></v-text-field>
      </v-col>
      <v-col cols="12" md="4" sm="6">
        <AutocompleteSelectCreateLegalPerson
                                             :user="user"
                                             :customTypes="[$LEGAL_PEOPLE_TYPES_DIC.GRUPO]"
                                             :person-type="$LEGAL_PEOPLE_TYPES_DIC.GRUPO"
                                             v-model="editGroup.legal_person"
                                             @selected="selectedLegalPerson"
                                             label="Selecione um cadastro" />
      </v-col>
      <!-- <v-col cols="12" md="4" sm="6" v-else>
        {{editGroup?.legal_person?.name}} - {{editGroup?.legal_person?.ssn}}
      </v-col> -->

      <v-col v-if="editGroup.img" cols="6" class="text-center">
        <img
             class="mx-auto"
             style="max-height: 200px; max-width: 100%"
             :src="editGroup.img" />
      </v-col>
      <v-col :cols="editGroup.img ? 6 : 12">
        <UploadFile
                    accept-type="image/png, image/jpeg, image/bmp"
                    icon="mdi-image"
                    :fileType="$FILE_TYPE.group_image"
                    :userId="user.id"
                    :groupId="editGroup.id"
                    @uploaded="uploadedGroupImage"
                    density="compact" />
      </v-col>
      <v-col cols="12">
        <v-text-field
                      label="URL da imagem do grupo"
                      v-model="editGroup.img"
                      density="compact"></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-textarea
                    label="Descrição"
                    v-model="editGroup.description"
                    hide-details
                    counter
                    density="compact"></v-textarea>
      </v-col>
      <v-col cols="12" class="text-right">
        <v-btn color="success" type="submit" density="compact">
          <v-icon class="mr-2">mdi-content-save</v-icon>
          Salvar
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import AutocompleteSelectCreateLegalPerson from "./AutocompleteSelectCreateLegalPerson.vue";
import ListFromTo from "./ListFromTo.vue";
import UploadFile from "./UploadFile.vue";
import api from '@/services'
import functions from '@/services/Functions'
export default {
  components: { ListFromTo, UploadFile, AutocompleteSelectCreateLegalPerson },
  props: {
    user: Object,
    group: Object,
    admin: Boolean,
  },
  data() {
    return {
      requestingApi: null,
      editGroup: {
        legal_person_id: null,
      },
      rules: {
        required: [(v) => !!v || "Campo obrigatório"],
      },
    };
  },
  created() {
    var vm = this;
    vm.editGroup = vm.group || vm.generateEmpty();
  },
  mounted() { },
  activated() { },
  methods: {
    selectedLegalPerson(legalPerson) {
      var vm = this;
      vm.editGroup.legal_person = legalPerson
      vm.editGroup.legal_person_id = legalPerson.id;
    },
    submitUpdate() {
      var vm = this;
      vm.requestingApi = true;
      return new Promise((resolve, reject) => {
        api.group
          .update(vm.editGroup)
          .then((result) => {
            vm.$emit("updated", result);
            vm.$notify({
              type: "success",
              text: "Dados alterados com sucesso",
            });
          })
          .catch((err) => {
            if (err?.response?.status === 403) {
              vm.$notify({
                type: "error",
                text: err.response.data.message,
              });
            } else if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
          })
          .finally(() => {
            vm.requestingApi = false;
          });
      });
    },
    uploadedGroupImage(image) {
      var vm = this;
      vm.editGroup.img = image.path;
    },
    generateEmpty() {
      return {
        acronym: null,
        name: null,
        description: null,
        img: null,
        configuration: null,
      };
    },
  },
  computed: {},
  watch: {
    group(newVal) {
      console.debug("GROUP changed", newVal);
      this.editGroup = newVal || this.generateEmpty();
    },
  },
};
</script>